import { useMemo, useState } from 'react'
import CicloEntregaAcoesHttp from '../../../../../services/api/https/deliveries/ciclo-entrega-acoes.http'
import { parseToMysqlFormat } from '../../../../../services/util/date.service'
import { errorHandler } from '../../../../../services/util/error.service'

const INITIAL_STATE = {
  programacao: [],
  errorMessage: null,
  successMessage: null,
  loadingMessage: null,
}

export default function useRevisaoDataProgramacaoState() {
  const [state, setState] = useState({ ...INITIAL_STATE })

  // Public
  const localDispatcher = useMemo(() => {
    return {
      async fetchProgramacao(ciclo) {
        try {
          setState(prevState => ({
            ...prevState,
            loadingMessage: 'Carregando as Datas de Programação',
          }))
          const programacao = await CicloEntregaAcoesHttp.getRevisaoDataProgramacao(ciclo.id)
          setState(prevState => ({ ...prevState, loadingMessage: null, programacao }))
        } catch (error) {
          setState(prevState => ({
            ...prevState,
            loadingMessage: null,
            errorMessage: errorHandler(error),
          }))
        }
      },
      resetMessages() {
        setState(prevState => ({ ...prevState, errorMessage: null, successMessage: null }))
      },
      onDataProgramacaoChange(data_programacao, item) {
        setState(prevState => {
          const index = prevState.programacao.findIndex(p => p.id === item.id)
          if (index !== -1) {
            prevState.programacao[index] = { ...item, data_programacao }
          }
          return { ...prevState }
        })
      },
      async onSalvar(programacao) {
        try {
          setState(prevState => ({
            ...prevState,
            loadingMessage: 'Atualizando as Datas de Programação',
          }))
          const info = programacao.map(p => ({
            associacao_id: p.id,
            data_programacao:
              typeof p.data_programacao === 'string'
                ? parseToMysqlFormat(new Date(p.data_programacao))
                : parseToMysqlFormat(p.data_programacao),
          }))
          await CicloEntregaAcoesHttp.updateDataProgramacao(info)
          setState(prevState => ({
            ...prevState,
            loadingMessage: null,
            successMessage: 'Operação realizada com sucesso',
          }))
        } catch (error) {
          setState(prevState => ({
            ...prevState,
            loadingMessage: null,
            errorMessage: errorHandler(error),
          }))
        }
      },
    }
  }, [])

  return { state, localDispatcher }
}
